import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {buildQuery} from "utils/uri";

export default function initDcDocument(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DOCUMENT_FETCH,
    (organisationId, projectId, matterId, documentId, options?) => {
      return requestor
        .get(
          `${basePath}/organisation/${organisationId}/project/${projectId}/matter/${matterId}/document/${documentId}${buildQuery(
            options,
          )}`,
          {withCredentials: true},
        )
        .then(response => {
          const responseData = response.data;

          return {
            document_id: responseData.id,
            ...responseData,
          };
        });
    },
  );
}
